import HomePopupBannerEdit from '@components/feed/HomePopupBannerEdit';
import { useAuthentication } from '@hooks/authentication';
import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import * as benepiaApi from '@apis/benepia';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Feed, FeedData, FeedDataItem } from '@models/feed';
import { removeTempProperties } from '@utils/dataTransform';
import { useOkCancelDialog } from '@stores/okCancelDialogStore';

const BENEPIA_MAIN_FEED_TYPE = 'benepia-main-feed';
const CURATION_WIDE_BANNERS_TYPE = 'curation-wide-banners';
const WIDE_BANNER_ITEM_TYPE = 'wide-banner';

export const BenepiaBannersPage: React.FC = () => {
  const [curationWideBannersData, setCurationWideBannersData] = useState<Partial<FeedData<FeedDataItem>>>();
  const [modifiedFiles, setModifiedFiles] = useState<{ [key: string]: File }>({});
  const dialog = useOkCancelDialog();

  useAuthentication();

  const mainFeedQuery = useQuery({
    queryKey: ['benepia-main-feed'],
    queryFn: () => benepiaApi.getBenepiaMainFeed(),
  });

  const benepiaMainFeed = mainFeedQuery.data?.data as Feed<FeedData<FeedDataItem>> | undefined;

  const updateCurationWideBannersMutation = useMutation({
    mutationFn: benepiaApi.updateBenepiaMainFeed,
    onSuccess: async () => {
      dialog.open({ type: 'ok', title: '알림', content: '배너를 수정했습니다' });
      mainFeedQuery.refetch();
    },
    onError: async (e) => {
      dialog.open({ type: 'ok', title: '오류', content: JSON.stringify(e) });
    },
  });

  useEffect(() => {
    if (benepiaMainFeed?.type === BENEPIA_MAIN_FEED_TYPE) {
      const curationWideBanners = benepiaMainFeed.data?.find((item) => item.type === CURATION_WIDE_BANNERS_TYPE);
      setCurationWideBannersData(curationWideBanners);
    }
  }, [benepiaMainFeed]);

  return (
    <div className="dashboard" style={{ position: 'relative' }}>
      <div className="page-header">
        <div>베네피아 배너 관리</div>
      </div>
      <div style={{ display: 'flex' }}>
        <div className="page-content" style={{ width: '100%', height: 'calc(100vh - 80px)', overflow: 'auto' }}>
          <div>
            <Button
              onClick={() => {
                const formData: FormData = new FormData();
                const json = {
                  ...curationWideBannersData,
                  type: CURATION_WIDE_BANNERS_TYPE,
                  data: curationWideBannersData?.data?.map((item) => ({
                    ...item,
                    type: WIDE_BANNER_ITEM_TYPE,
                  })),
                };
                json.data = removeTempProperties(json.data);

                formData.append('json', JSON.stringify(json));
                Object.values(modifiedFiles).forEach((file) => {
                  formData.append('files', file);
                });
                updateCurationWideBannersMutation.mutate(formData);
              }}>
              저장
            </Button>
          </div>
          <div>
            <HomePopupBannerEdit
              hideSettings
              data={curationWideBannersData}
              onChange={(data) => {
                setCurationWideBannersData(data);
              }}
              onChangeImageFile={(files) => {
                setModifiedFiles((prev) => {
                  return { ...prev, ...files };
                });
              }}></HomePopupBannerEdit>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenepiaBannersPage;
